export default __webpack_public_path__ + "static/media/02.5fbe9bb5.png";